<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "PJProposalInsuranceHistory",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>F. Insurance History (if any)</div>"
					},
					bindTo: ""
				},
				{
					label: "1. Name of Previous Insurer",
					component: "text",
					bindTo: "case.facts.previousInsurer"
				},
				{
					label: "2. Date of policy expiry",
					component: "date",
					dataType: "date",
					bindTo: "case.facts.policyExpiryDate"
				},
				{
					label:
						"3. Has any insurer declined to accept, refuse to continue or agree to continue only on special terms, any insurance for the Proposer or any other person to whom this insurance will apply?",
					component: "select",
					bindTo: "case.facts.isInsuranceDeclinedOrRefused",
					props: {
						options: [
							{
								name: "No",
								value: "No"
							},
							{
								name: "Yes",
								value: "Yes"
							}
						]
					}
				},
				{
					label: '3. If chose "Yes", please give details',
					component: "text",
					bindTo: "case.facts.insuranceDeclinedOrRefusedDetails"
				},
				{
					label:
						"4. Has the proposer, or any other whose property is to be insured hereunder, sustained any loss or damage during the past six years which would have been covered by this type of insurance had it been in force?",
					component: "select",
					bindTo: "case.facts.isLossOrDamageSustainedInPastSixYears",
					props: {
						options: [
							{
								name: "No",
								value: "No"
							},
							{
								name: "Yes",
								value: "Yes"
							}
						]
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="fs4 fw7 lh125">3. If chose "Yes", please give details</div>'
					},
					bindTo: ""
				},
				{
					label: "3. Date",
					component: "date",
					dataType: "date",
					bindTo: "case.facts.lossOrDamageSustainedInPastSixYearsDate"
				},
				{
					label: "3. Amount",
					component: "text",
					bindTo: "case.facts.lossOrDamageSustainedInPastSixYearsAmount"
				},
				{
					label: "3. Circumstance",
					component: "text",
					bindTo: "case.facts.lossOrDamageSustainedInPastSixYearsCircumstance"
				},
				{
					label: "3. With whom the property was insured",
					component: "text",
					bindTo:
						"case.facts.lossOrDamageSustainedInPastSixYearsInsuredPropertyOwner"
				}
			]
		}
	}
}
</script>
